import { memo, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors, ModalProps } from 'Types';
import {
	Button,
	ModalBox,
	ModalBoxFooter,
	SubmitButton,
	FontAwesome,
	Card
} from 'Elements';

interface Props extends ModalProps {
	isLoading: boolean;
	onPublish: () => void;
}

export const ModalBoxPublishJobTop: FC<Props> = memo(
	({ isOpen, isLoading, onPublish, onClose }) => {
		const { t } = useTranslation();
		return (
			<ModalBox isOpen={isOpen}>
				<header className="d-flex flex-column">
					<span className="fs-base fw-500">
						{t('text.publish-job-as-top-list')}
					</span>
					<p className="text-gray-3 mt-2">
						{t('text.description-publish-job-as-top-list')}
					</p>
					<Card className="w-100 d-flex my-3 py-2 rounded-3 align-items-center shadow-none infinite gap-1 bg-yellow_o-2 text-yellow">
						<FontAwesome
							icon="info-circle"
							size="1x"
							className="me-2"
						/>
						{t(
							'text.by-publishing-one-of-the-capacities-will-be-used'
						)}
					</Card>
				</header>
				<ModalBoxFooter className="justify-content-between pt-3">
					<Button
						color={Colors.red}
						label={t('button.cancel') as string}
						onClick={onClose}
					/>
					<SubmitButton
						icon=""
						color={Colors.primary}
						isSubmitting={isLoading}
						label="button.publish-job-as-top-list"
						savingLabel="button.publishing"
						onClick={onPublish}
					/>
				</ModalBoxFooter>
			</ModalBox>
		);
	}
);

ModalBoxPublishJobTop.displayName = 'ModalBoxPublishJobTop';
